import { combineReducers } from 'redux'

import anexosObrasParadas from './anexosObrasParadas'

export default combineReducers({ anexosObrasParadas })
